import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/AuthenticationBoundary';
import Icon from '../../components/AppIcon';
import LoginForm from './components/LoginForm';
import SecurityIndicator from './components/SecurityIndicator';
import SystemStatus from './components/SystemStatus';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin-orders-management');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-card rounded-2xl shadow-card p-8 lg:p-12">
            <div className="mb-8">
              <div className="flex items-center space-x-3 mb-6">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent/10">
                  <Icon name="Shield" size={28} color="var(--color-accent)" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-foreground">관리자 로그인</h1>
                  <p className="text-sm text-muted-foreground">SneakerCare Pro 관리 시스템</p>
                </div>
              </div>
              <p className="text-sm text-muted-foreground">
                관리자 계정으로 로그인하여 주문, 상품, 고객 및 약관을 관리하세요.
              </p>
            </div>

            <LoginForm />

            <div className="mt-8 pt-6 border-t border-border">
              <div className="flex items-center justify-center space-x-2 text-xs text-muted-foreground">
                <Icon name="Info" size={14} />
                <span>문제가 발생하면 시스템 관리자에게 문의하세요</span>
              </div>
            </div>
          </div>

          <div className="hidden lg:block space-y-6">
            <div className="bg-card rounded-2xl shadow-card p-8">
              <div className="mb-6">
                <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 mb-4">
                  <Icon name="Sparkles" size={32} color="var(--color-primary)" />
                </div>
                <h2 className="text-xl font-bold text-foreground mb-2">SneakerCare Pro</h2>
                <p className="text-sm text-muted-foreground">
                  전문적인 운동화 클리닝 서비스를 위한\n통합 관리 플랫폼
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-success/10 flex-shrink-0">
                    <Icon name="ShoppingCart" size={20} color="var(--color-success)" />
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground mb-1">주문 관리</h3>
                    <p className="text-xs text-muted-foreground">실시간 주문 추적 및 상태 업데이트</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent/10 flex-shrink-0">
                    <Icon name="Package" size={20} color="var(--color-accent)" />
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground mb-1">상품 관리</h3>
                    <p className="text-xs text-muted-foreground">서비스 유형 및 가격 설정</p>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-warning/10 flex-shrink-0">
                    <Icon name="Users" size={20} color="var(--color-warning)" />
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground mb-1">고객 관리</h3>
                    <p className="text-xs text-muted-foreground">고객 데이터베이스 및 이용 통계</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-card rounded-2xl shadow-card p-8">
              <SecurityIndicator />
            </div>

            <div className="bg-card rounded-2xl shadow-card p-8">
              <SystemStatus />
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <button
            onClick={() => navigate('/customer-home')}
            className="inline-flex items-center space-x-2 text-sm text-muted-foreground hover:text-foreground transition-colors duration-150"
          >
            <Icon name="ArrowLeft" size={16} />
            <span>고객 홈페이지로 돌아가기</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;